import { render } from "./DefaultAvatar.vue?vue&type=template&id=b87ea77e&scoped=true"
import script from "./DefaultAvatar.vue?vue&type=script&lang=js"
export * from "./DefaultAvatar.vue?vue&type=script&lang=js"

import "./DefaultAvatar.vue?vue&type=style&index=0&id=b87ea77e&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87ea77e"]])

export default __exports__